<script>
export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.icon">
      <svg
        :class="$style.doc"
        viewBox="0 0 120 150">
        <path
          :class="$style.page"
          d="M28 16 H78 L98 36 V134 H28 Z" />
        <path
          :class="$style.fold"
          d="M78 16 V36 H98 Z" />
        <text
          :class="$style.qmark"
          x="60"
          y="106">?</text>
      </svg>
      <span :class="$style.shadow"/>
    </div>
    <h3 :class="$style.text">{{ $t('NOT_FOUND.TITLE') }}</h3>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.doc {
  width: 120px;
  height: 150px;
  color: $orange-primary;
  animation: float 2.4s ease-in-out infinite;
}

.page {
  fill: #fff;
  stroke: currentColor;
  stroke-width: 5;
  stroke-linejoin: round;
}

.fold {
  fill: rgba($orange-primary, 0.15);
  stroke: currentColor;
  stroke-width: 5;
  stroke-linejoin: round;
}

.qmark {
  font-size: 56px;
  font-weight: 700;
  text-anchor: middle;
  fill: currentColor;
}

.shadow {
  width: 70px;
  height: 12px;
  margin-top: 4px;
  background: $slate-grey;
  border-radius: 50%;
  opacity: 0.15;
  filter: blur(2px);
  animation: shadow 2.4s ease-in-out infinite;
}

.text {
  margin-top: 2rem;
  color: $slate-grey;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes shadow {
  0%,
  100% {
    transform: scaleX(1);
    opacity: 0.15;
  }
  50% {
    transform: scaleX(0.7);
    opacity: 0.08;
  }
}
</style>
